import roundToNDecimals from './roundToNDecimals';

export default roundToNDecimals;
